import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { KeywordSwitchNode } from '../../types';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import { KEYWORD_SWITCH_SOURCE_HANDLES } from '../keywordSwitchHandles';
import { CardShell } from '../CardShell';

export const KeywordSwitchNodeView = memo(function KeywordSwitchNodeView({ data }: NodeProps<KeywordSwitchNode>) {
  const displayLanguage = useFlowDisplayLanguage();
  const keyword1 = typeof data.keyword1 === 'string' ? data.keyword1 : '';
  const keyword2 = typeof data.keyword2 === 'string' ? data.keyword2 : '';
  const summary = keyword1 || keyword2
    ? `${keyword1 || '—'} / ${keyword2 || '—'}`
    : displayLanguage === 'en' ? 'Not set' : '未設定';

  return (
    <CardShell
      kind="keywordSwitch"
      accent="teal"
      title={getNodeDisplayLabel('keywordSwitch', displayLanguage)}
      summary={summary}
    >
      <div className="flow-node__port-label flow-node__port-label--in text-teal-700" style={{ top: '50%', transform: 'translateY(-50%)' }}>
        {displayLanguage === 'en' ? 'input' : '入力'}
      </div>
      <div className="flow-node__port-label flow-node__port-label--out text-teal-700" style={{ top: '26%', transform: 'translateY(-50%)' }}>
        {displayLanguage === 'en' ? 'no match' : 'どちらでもない'}
      </div>
      <div className="flow-node__port-label flow-node__port-label--out text-teal-700" style={{ top: '50%', transform: 'translateY(-50%)' }}>
        {displayLanguage === 'en' ? 'keyword 1' : 'キーワード1'}
      </div>
      <div className="flow-node__port-label flow-node__port-label--out text-teal-700" style={{ top: '74%', transform: 'translateY(-50%)' }}>
        {displayLanguage === 'en' ? 'keyword 2' : 'キーワード2'}
      </div>

      <Handle type="target" position={Position.Left} style={{ top: '50%' }} className="!bg-teal-500" />
      <Handle
        id={KEYWORD_SWITCH_SOURCE_HANDLES.default}
        type="source"
        position={Position.Right}
        style={{ top: '26%' }}
        className="!bg-teal-500"
      />
      <Handle
        id={KEYWORD_SWITCH_SOURCE_HANDLES.match1}
        type="source"
        position={Position.Right}
        style={{ top: '50%' }}
        className="!bg-teal-500"
      />
      <Handle
        id={KEYWORD_SWITCH_SOURCE_HANDLES.match2}
        type="source"
        position={Position.Right}
        style={{ top: '74%' }}
        className="!bg-teal-500"
      />
    </CardShell>
  );
});
